import { FetchContext } from '../fetch-context';
import { EmailTemplate } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getEmailTemplate: (
  fetchContext: FetchContext,
  programId: number,
  emailTemplateId: number,
  accessToken?: string,
) => Promise<EmailTemplate> = (fetchContext, programId, emailTemplateId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/${emailTemplateId}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<EmailTemplate>(fetchContext.errorStore, response, 'get email template'));
